module.exports = __webpack_public_path__ + "static/paris-015-1256da6cea638244caf546a443c75df8.jpg";